const NodeCloneIdentityPolicy = Object.freeze({
    PreserveIdentity: "preserve-identity",
    RegenerateIdentity: "regenerate-identity",
});

export default NodeCloneIdentityPolicy;
